import { CoffeeOutlined } from "@ant-design/icons"
import { type EventContentArg } from "@fullcalendar/core"
import { Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface CalendarEventCellBreakProps {
  eventInfo: EventContentArg
}

// The break is a schedule-derived non-working period (working-schedule.ts's
// scheduleToBreakEvents), not a real appointment — a real but non-editable
// event styled in calendar.less to read as a spanning band rather than an
// appointment. This only has to label what that band already covers.
export function CalendarEventCellBreak({ eventInfo }: CalendarEventCellBreakProps) {
  // The Calendar page itself keeps break events out of these views entirely
  // (a spanning band reads as a real row/cell there); this is a defensive
  // no-op, not relied on.
  const isListView = !!eventInfo?.view?.type?.startsWith("list")
  const isMonthView = eventInfo?.view?.type === "dayGridMonth"
  if (isListView || isMonthView) return null

  return (
    <Flex
      align="center"
      justify="center"
      gap={4}
      wrap={false}
      className="size-full min-w-0 overflow-hidden whitespace-nowrap px-1 text-gray-500"
      data-testid="calendar-break-block"
    >
      <CoffeeOutlined className="shrink-0 text-xs" />
      <Text
        ellipsis
        className="min-w-0 shrink-0 text-[11px] font-medium leading-none text-inherit"
      >
        Break
      </Text>
      {eventInfo?.timeText && (
        <Text
          ellipsis
          className="min-w-0 text-[11px] leading-none text-inherit opacity-75"
        >
          {eventInfo.timeText}
        </Text>
      )}
    </Flex>
  )
}
